import ENVIRONMENTS from "@/constants/ENVIRONMENTS"
import { Button, Menu, MenuItem } from "@material-ui/core"
import { OpenInNew } from "@material-ui/icons"
import React, { useState } from "react"

const EnvSwitcherButton: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (baseUrl: string) => {
    const { pathname, search, hash } = window.location
    const fullUrl = `${baseUrl}${pathname}${search}${hash}`
    window.open(fullUrl, "_blank", "noopener,noreferrer")
    handleClose()
  }

  return (
    <>
      <Button
        aria-controls="env-menu"
        aria-haspopup="true"
        color="inherit"
        size="small"
        variant="outlined"
        onClick={handleClick}
        startIcon={<OpenInNew />}
      >
        ENV
      </Button>
      <Menu
        id="env-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {ENVIRONMENTS.map(env => (
          <MenuItem key={env.label} onClick={() => handleSelect(env.url)}>
            {env.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default EnvSwitcherButton
